import React from 'react'

import { radioType } from 'common/types'
import { T } from 'components/Translations'
import StyledRadio, { RadioCustom } from './StyledRadio'

const Radio = ({ label, text, ...rest }) => {
  const id = `Radio-${rest.name}-${rest.value}`
  text = label ? <T label={label} /> : text

  return (
    <StyledRadio>
      <input id={id} type="radio" {...rest} />
      {text && <label htmlFor={id}>{text}</label>}
      <RadioCustom />
    </StyledRadio>
  )
}

Radio.propTypes = radioType

Radio.defaultProps = {
  checked: false,
  required: false,
}

export default Radio
